<template lang="pug">
v-dialog(v-model="dialog" max-width="500px")
  v-card
    v-card-title
      span.s1 Payment Receipt
    v-card-text
      v-form(ref="form" v-model="valid")
        v-text-field(
          v-model="paymentAmount"
          label="Payment Amount"
          type="number"
          :rules="[v => !!v || 'Payment amount is required']"
          required
        )
        v-select(
          v-model="paymentMethod"
          :items="paymentMethods"
          label="Payment Method"
          :rules="[v => !!v || 'Payment method is required']"
          required
        )
        v-text-field(
          v-model="referenceId"
          label="Reference ID (Optional)"
        )
        v-file-input(
          v-model="proofOfPayment"
          label="Proof of Payment"
          accept="image/jpeg, application/pdf"
          :rules="[v => !!v || 'Proof of payment is required']"
          required
        )
    v-card-actions
      v-spacer
      v-btn(color="blue darken-1" text @click="close") Cancel
      v-btn.textColorAccent.white--text(@click="submit" :disabled="!valid") Submit
</template>

<script>
import axios from 'axios';

export default {
  props: {
    invoicePid: {
      type: String,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    valid: false,
    paymentAmount: null,
    paymentMethod: null,
    referenceId: '',
    proofOfPayment: null,
    paymentMethods: [
      { text: 'Cash', value: 'cash' },
      { text: 'Bank Transfer', value: 'bank_transfer' },
      { text: 'ATM Transfer', value: 'atm_transfer' }
    ]
  }),
  methods: {
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
      this.$refs.form.reset()
    },
    async getLeadId() {
      try {
        const response = await axios.get(`https://yezza-api.arbatravel.com/leads/${this.invoicePid}`);
        return response.data.id;
      } catch (error) {
        console.error('Error fetching lead ID:', error);
        throw error;
      }
    },
    async createTransaction(leadId) {
      const transactionData = {
        amount: this.paymentAmount*100,
        gateway: "direct",
        lead: leadId,
        ref_id: this.referenceId || null,
        payment_method: this.paymentMethod,
        internal_description: null
      };

      try {
        const response = await axios.post('https://yezza-api.arbatravel.com/transactions', transactionData);
        return response.data.uid;
      } catch (error) {
        console.error('Error creating transaction:', error);
        throw error;
      }
    },
    async uploadFile(uid) {
      const formData = new FormData();
      formData.append('file', this.proofOfPayment);

      try {
        await axios.patch(`https://yezza-api.arbatravel.com/transactions/${uid}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          const leadId = await this.getLeadId();
          const transactionUid = await this.createTransaction(leadId);
          await this.uploadFile(transactionUid);

          this.$emit('payment-submitted', transactionUid);
          this.close();
        } catch (error) {
          console.error('Error in submission process:', error);
          // Handle error (e.g., show error message to user)
        }
      }
    }
  }
}
</script>